import React from 'react';
import { ReactComponent as WarningIcon } from '../../images/warning-triangle.svg';
import { ReactComponent as ErrorIcon } from '../../images/error-hexagon.svg';
import { ReactComponent as SuccessIcon } from '../../images/success-square.svg';
import { ReactComponent as InformationIcon } from '../../images/information.svg';
import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../api/apiProvider';

interface Varsel {
  id: string;
  varslingstype: string;
  publisert: boolean;
  klienter: Klient[];
  synligFra: string;
  synligTil: string;
  tekst: string;
}

interface Klient {
  key: string;
  visningsnavn: string;
}

const Varsel = (): JSX.Element => {
  const { urls, api } = useApi();
  const klienKey = 'bymelding-portal';

  const { data } = useQuery<Varsel[]>({
    queryKey: ['notification-service-statiske-data'],
    queryFn: async () => {
      try {
        const response = await api.get(urls.getNotificationServiceVarselData(klienKey));
        const responseData = response.data;
        return responseData;
      } catch (error) {
        //console.log('Kunne ikke hente varsler');
      }
    },
    onError: (error: any) => {
      console.error(error);
    },
  });

  if (!data || data.length === 0) return <></>;

  const varselType = (varselType: string): string => {
    switch (varselType) {
      case 'Advarsel':
        return 'border-yellow bg-yellow-50';
      case 'Feil':
        return 'border-red bg-red-30';
      case 'FeilRettet':
        return 'border-green bg-green-30';
      default:
        return 'border-blue bg-blue-60';
    }
  };
  const icon = (varselType: string): JSX.Element => {
    switch (varselType) {
      case 'Advarsel':
        return <WarningIcon aria-hidden />;
      case 'Feil':
        return <ErrorIcon aria-hidden />;
      case 'FeilRettet':
        return <SuccessIcon aria-hidden />;
      default:
        return <InformationIcon aria-hidden />;
    }
  };

  return (
    <>
      {data.map((varsel) => (
        <div
          key={varsel.id}
          className={`flex gap-[16px] w-full p-3 mt-3 tablet:px-[40px] border-0 border-l-2 border-solid ${varselType(
            varsel.varslingstype
          )}`}
        >
          <div className="min-h-[24px] min-w-[24px]">{icon(varsel.varslingstype)} </div>
          <div className="text-4" dangerouslySetInnerHTML={{ __html: varsel.tekst }} />
        </div>
      ))}
    </>
  );
};

export default Varsel;
